import React, {Component} from 'react';
import Header from "./header";
import "./homePage.css";
import Slider from "react-slick";
import Footer from "./footer";
import Articles from "../articles/articles";
import { Responsive, Container, Grid, Image } from 'semantic-ui-react';
import HistoryItem from "./historyitem";
import FacebookProvider, { Page } from 'react-facebook';
import YouTube from 'react-youtube';
import OurBackground from './img/ourbg.jpg';
import CoreValues from './img/core.jpg';
import HistoryData from "./data/history.json";
class ContactUs extends Component {
  state = {
    history:[]
  }
  componentWillMount(){
      this.setState({
        history:HistoryData,
      });

  }

  render() {
    const opts = {
      width:"1040",
      height:"584",
      playerVars: { // https://developers.google.com/youtube/player_parameters
        autoplay: 1
      }
    };

    return (
      <div className="Homepage">

        <Header page="aboutus"/>

          <div className="homeContentWhite">
            <a id="overview">
              <Container>


                <div className="AboutUsText left">
                  You are welcome to contact us by
                  <br/><br/>
                  <Grid>
                    <Grid.Row>
                      <Grid.Column mobile={4} tablet={4} computer={4}>
                        <span className="AboutUsText left">Email:</span>
                      </Grid.Column>
                      <Grid.Column mobile={12} tablet={12} computer={12}>
                        <a href="mailto:info@rccentral.org">info@rccentral.org</a>
                      </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                      <Grid.Column mobile={4} tablet={4} computer={4}>
                        <span className="AboutUsText left">Postal Address:</span>
                      </Grid.Column>
                      <Grid.Column mobile={12} tablet={12} computer={12}>
                        GPO Box 10448 Hong Kong (香港郵政總局郵箱10448號)
                      </Grid.Column>
                    </Grid.Row>

                  <Grid.Row>
                    <Grid.Column mobile={4} tablet={4} computer={4}>
                     <span className="AboutUsText left">Regular Meeting:</span>
                    </Grid.Column>
                    <Grid.Column mobile={12} tablet={12} computer={12}>
                      Every Wednesday, except 4th Wednesday of the month <br/>
                      (<a href="/events">Please refer to "Events" section for the most updated meetings venue & activities</a>)
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column mobile={4} tablet={4} computer={4}>
                     <span className="AboutUsText left">Time:</span>
                    </Grid.Column>
                    <Grid.Column mobile={12} tablet={12} computer={12}>
                      7:30-9:30pm
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column mobile={4} tablet={4} computer={4}>
                     <span className="AboutUsText left">Venue:</span>
                    </Grid.Column>
                    <Grid.Column mobile={12} tablet={12} computer={12}>
                      Lingnan Club (嶺南會所)<br/>
                      12-13/F, On Lok Yuen Buildling, 25-27A Des Vouex Road, Central<br/>
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column mobile={4} tablet={4} computer={4}>
                     <span className="AboutUsText left"></span>
                    </Grid.Column>
                    <Grid.Column mobile={12} tablet={12} computer={12}>
                      (Nearest MTR = Central Station Exit B)
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
                  <div className="map">
                    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3691.8873032491815!2d114.15424173343615!3d22.282258453231215!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x340400649f73a081%3A0x747fe80c492dcc5c!2z5ba65Y2X5pyD5omAIExpbmduYW4gQ2x1Yg!5e0!3m2!1sen!2shk!4v1675665568827!5m2!1sen!2shk"  width="100%" height="450" frameborder="0" allowfullscreen loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                  </div>
                  {/* The contact form is commented out because it's not working and the client doesn't have budget to fix this function */}
                  {/* <div className="ContactUsBox">
                    <div className="AboutUsTitle">
                      Contact Us
                    </div>
                    <div className="ContactUsContent">
                    <Grid centered columns='equal'>
                      <Grid.Row>
                        <Grid.Column mobile={16} tablet={12} computer={4}>
                          <p>{"Your Name".toUpperCase()}</p>
                          <input type="text" id="name" value={this.state.name} />
                        </Grid.Column>
                        <Grid.Column mobile={16} tablet={12} computer={4}>
                          <p>{"Email".toUpperCase()}</p>
                          <input type="text" id="email" value={this.state.email} />
                        </Grid.Column>
                        <Grid.Column mobile={16} tablet={12} computer={4}>
                          <p>{"Subject".toUpperCase()}</p>
                          <input type="text" id="subject" value={this.state.subject} />
                        </Grid.Column>
                      </Grid.Row>
                      <Grid.Row>
                        <Grid.Column mobile={16} tablet={12} computer={12}>
                          <textarea type="text" id="content" value={this.state.content} />
                        </Grid.Column>

                      </Grid.Row>

                    </Grid>
                      <div className="send">
                       SEND
                      </div>
                    </div>
                  </div> */}
                </div>
              </Container>
            </a>
          </div>

        <Footer/>
      </div>
    );
  }
}

export default ContactUs;
